/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why can I read the payload without a password?`)
};

const es_jw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué puedo leer la carga útil sin una contraseña?`)
};

const de_jw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum kann ich die Payload ohne Passwort lesen?`)
};

const nl_jw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom kan ik de payload zonder wachtwoord lezen?`)
};

const fr_jw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi puis-je lire la charge utile sans mot de passe ?`)
};

const it_jw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché posso leggere il payload senza una password?`)
};

const pt_br2_jw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que posso ler o payload sem uma senha?`)
};

const pt_jw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que posso ler a carga sem uma senha?`)
};

const ja_jw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードなしでペイロードを読むことができるのはなぜですか？`)
};

const zh_jw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么不需要密码就能读取载荷？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jw_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jw_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jw_faq4_q", locale)
	if (locale === "en") return en_jw_faq4_q(inputs)
	if (locale === "es") return es_jw_faq4_q(inputs)
	if (locale === "de") return de_jw_faq4_q(inputs)
	if (locale === "nl") return nl_jw_faq4_q(inputs)
	if (locale === "fr") return fr_jw_faq4_q(inputs)
	if (locale === "it") return it_jw_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_jw_faq4_q(inputs)
	if (locale === "pt") return pt_jw_faq4_q(inputs)
	if (locale === "ja") return ja_jw_faq4_q(inputs)
	return zh_jw_faq4_q(inputs)
};